module.exports = __webpack_public_path__ + "img/logo.79b618f2.png";